import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ShoppingCart } from 'lucide-react';
import Logo from './Logo';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#F5F1E8] border-b border-[#E5DCC8]">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="hover:opacity-80 transition-opacity">
            <Logo variant="dark" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-[#5C4033] hover:text-[#8B6F47] transition-colors">
              Product
            </Link>
            <Link to="/nutrition" className="text-[#5C4033] hover:text-[#8B6F47] transition-colors">
              Nutrition
            </Link>
            <Link to="/about" className="text-[#5C4033] hover:text-[#8B6F47] transition-colors">
              About
            </Link>
            <Link to="/project" className="text-[#5C4033] hover:text-[#8B6F47] transition-colors">
              GUAG/PROJECT
            </Link>
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <button className="text-[#5C4033] hover:text-[#8B6F47] transition-colors">
              <ShoppingCart size={20} />
            </button>
            <Link
              to="/nutrition"
              className="px-6 py-2.5 bg-[#8B6F47] text-white rounded-full hover:bg-[#5C4033] transition-colors font-medium"
            >
              Buy
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#5C4033]"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3">
            <Link to="/" className="block text-[#5C4033] hover:text-[#8B6F47] transition-colors">
              Product
            </Link>
            <Link to="/nutrition" className="block text-[#5C4033] hover:text-[#8B6F47] transition-colors">
              Nutrition
            </Link>
            <Link to="/about" className="block text-[#5C4033] hover:text-[#8B6F47] transition-colors">
              About
            </Link>
            <Link to="/project" className="block text-[#5C4033] hover:text-[#8B6F47] transition-colors">
              GUAG/PROJECT
            </Link>
            <div className="flex items-center space-x-4 pt-3">
              <button className="text-[#5C4033]">
                <ShoppingCart size={20} />
              </button>
              <Link
                to="/nutrition"
                className="px-6 py-2.5 bg-[#8B6F47] text-white rounded-full hover:bg-[#5C4033] transition-colors font-medium"
              >
                Buy
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;